(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cas-non-releve', {
            parent: 'entity',
            url: '/cas-non-releve?page&sort&search',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.casNonReleve.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/cas-non-releve/cas-non-releves.html',
                    controller: 'CasNonReleveController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('casNonReleve');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cas-non-releve-detail', {
            parent: 'entity',
            url: '/cas-non-releve/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.casNonReleve.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/cas-non-releve/cas-non-releve-detail.html',
                    controller: 'CasNonReleveDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('casNonReleve');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CasNonReleve', function($stateParams, CasNonReleve) {
                    return CasNonReleve.get({id : $stateParams.id});
                }]
            }
        })
        .state('cas-non-releve.new', {
            parent: 'cas-non-releve',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cas-non-releve/cas-non-releve-dialog.html',
                    controller: 'CasNonReleveDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                libelle: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cas-non-releve', null, { reload: true });
                }, function() {
                    $state.go('cas-non-releve');
                });
            }]
        })
        .state('cas-non-releve.edit', {
            parent: 'cas-non-releve',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cas-non-releve/cas-non-releve-dialog.html',
                    controller: 'CasNonReleveDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CasNonReleve', function(CasNonReleve) {
                            return CasNonReleve.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('cas-non-releve', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cas-non-releve.delete', {
            parent: 'cas-non-releve',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/cas-non-releve/cas-non-releve-delete-dialog.html',
                    controller: 'CasNonReleveDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CasNonReleve', function(CasNonReleve) {
                            return CasNonReleve.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('cas-non-releve', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
